module.exports = __webpack_public_path__ + "img/ts.64194e85.png";